import { render } from "./bindingInfo.vue?vue&type=template&id=282176f9&scoped=true"
import script from "./bindingInfo.vue?vue&type=script&lang=js"
export * from "./bindingInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282176f9"]])

export default __exports__